// extracted by mini-css-extract-plugin
export default {"keyboardKey":"KeyboardKey_keyboardKey__MU181","white":"KeyboardKey_white__gfzmH","keyName":"KeyboardKey_keyName__BLwR1","black":"KeyboardKey_black__hex9o"};